export default {
  setQuotes(state, data) {
    state.quotes = data;
  },

  setListini(state, data) {
    state.quotes = data;
  },

  setSkipCheck(state, value) {
    state.skipCheck = value;
  },
  setClientChecked(state, value) {
    state.clientChecked = value;
  }
};
